enum StatementConciliationMovementOriginType {
  BANK = 'bank',
  ERP = 'erp',
}

export default StatementConciliationMovementOriginType;
